import { ActionType as AT } from './enums/action-type.enum';
import { Application } from './interfaces/application.interface';
import { Doctor } from '../../models/doctor.model';
import { Lead } from '../../models/lead.model';
import { Service } from '../../models/service.model';
import { ABTestCase } from '../../models/ab-test.model';
import { ConvrTestVariation } from '../../interfaces/convr-test-variation.interface';

export const defineClientData = (data: { [key: string]: any }) => ({
	type: AT.DEFINE_CLIENT_DATA as typeof AT.DEFINE_CLIENT_DATA,
	payload: { data }
});

export const updateDoctor = (doctor: Doctor) => ({
	type: AT.UPDATE_DOCTOR as typeof AT.UPDATE_DOCTOR,
	payload: { doctor }
});

export const addLead = (lead: Lead) => ({
	type: AT.ADD_LEAD as typeof AT.ADD_LEAD,
	payload: { lead }
});

export const updateLead = (leadFields: Pick<Lead, 'callTime' | 'appointment' | 'form_type'>) => ({
	type: AT.UPDATE_LEAD as typeof AT.UPDATE_LEAD,
	payload: { leadFields }
});

export const replaceHeaderPhone = (phone: string) => ({
	type: AT.REPLACE_PHONE as typeof AT.REPLACE_PHONE,
	payload: { phone }
});

export const defineAbTestCase = (abTestCase: ABTestCase) => ({
	type: AT.DEFINE_AB_TEST_CASE as typeof AT.DEFINE_AB_TEST_CASE,
	payload: { abTestCase }
});

export const setPhoneFormData = (phoneFormData: Application) => ({
	type: AT.SET_PHONE_FORM_DATA as typeof AT.SET_PHONE_FORM_DATA,
	payload: phoneFormData
});

export const enableWhatsApp = (status: boolean) => ({
	type: AT.ENABLE_WHATS_APP as typeof AT.ENABLE_WHATS_APP,
	payload: { status }
});

export const enableSpecialOffers = (status: any) => ({
	type: AT.ENABLE_SPECIAL_OFFERS as typeof AT.ENABLE_SPECIAL_OFFERS,
	payload: { status }
});

export const updateServiceList = (list: Service[]) => ({
	type: AT.UPDATE_SERVICE_LIST as typeof AT.UPDATE_SERVICE_LIST,
	payload: { list }
});

export const enableCommonServiceList = (status: boolean) => ({
	type: AT.ENABLE_COMMON_SERVICE_LIST as typeof AT.ENABLE_COMMON_SERVICE_LIST,
	payload: { status }
});

export const addTestVariations = (variations: ConvrTestVariation[]) => ({
	type: AT.ADD_TEST_VARIATIONS as typeof AT.ADD_TEST_VARIATIONS,
	payload: { variations }
});

export const addCustomContent = (customContent: Record<string, any>) => ({
	type: AT.ADD_CUSTOM_CONTENT as typeof AT.ADD_CUSTOM_CONTENT,
	payload: { customContent }
});

export const updateCustomLeadParams = (params: Record<string, any>) => ({
	type: AT.UPDATE_CUSTOM_LEAD_PARAMS as typeof AT.UPDATE_CUSTOM_LEAD_PARAMS,
	payload: { params }
});

export const updateCalculator = (calculator: Record<string, any>) => ({
	type: AT.UPDATE_CALCULATOR as typeof AT.UPDATE_CALCULATOR,
	payload: { calculator },
});

export const setPolicyAgreeStatus = () => ({
	type: AT.SET_POLICY_AGREE_STATUS as typeof AT.SET_POLICY_AGREE_STATUS
});